import { PaymentMethodTypes } from './adyen';

export function isPayPalPayment(paymentMethod?: PaymentMethodTypes | null): boolean {
  return paymentMethod === PaymentMethodTypes.PAYPAL;
}
